import { render, staticRenderFns } from "./card-with-tabs-boxer.vue?vue&type=template&id=29002c08&scoped=true&"
import script from "./card-with-tabs-boxer.vue?vue&type=script&lang=js&"
export * from "./card-with-tabs-boxer.vue?vue&type=script&lang=js&"
import style0 from "./card-with-tabs-boxer.vue?vue&type=style&index=0&id=29002c08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29002c08",
  null
  
)

export default component.exports